// components/avances/annulationPrivilegieeApi.js
// ============================================================================
// ANNULATION PRIVILÉGIÉE D'UNE AVANCE : APPELS ET PERMISSIONS
// ============================================================================
// Le serveur tranche (backend2/routes/avances.routes.js) ; les permissions lues
// ici évitent seulement de proposer ce qui serait refusé. Le passe-droit ne
// vient que d'une dérogation : la liste du serveur n'en contient pas d'autre.
// ============================================================================

import { getAuthHeaders } from '../../services/api';
import { usePermissions } from '../../hooks/usePermissions';

export const PERMISSION_ANNULATION_PRIVILEGIEE = 'COMPTABILITE_ET_PAIE.AVANCES.ANNULATION_PRIVILEGIEE';
const PERMISSION_LIRE_JOURNAL = 'COMPTABILITE_ET_PAIE.ETAT_SALAIRES.DEFIGER';
// Peut valider sa propre demande (double authentification exigée).
export const PERMISSION_SUPER_VALIDATEUR = 'COMPTABILITE_ET_PAIE.ACTIONS_PRIVILEGIEES.SUPER_VALIDER';

export const usePermissionsAnnulationPrivilegiee = () => {
  const { detailedPermissions } = usePermissions();
  const cles = new Set((detailedPermissions || []).map((p) => p.permission_key || p.key));
  const peutAnnuler = cles.has(PERMISSION_ANNULATION_PRIVILEGIEE);
  return {
    peutAnnuler,
    estSuperValidateur: cles.has(PERMISSION_SUPER_VALIDATEUR),
    peutLireJournal: peutAnnuler || cles.has(PERMISSION_LIRE_JOURNAL)
  };
};

const appeler = async (url, options = {}) => {
  const response = await fetch(url, { ...options, headers: getAuthHeaders() });
  const data = await response.json().catch(() => ({}));
  if (!response.ok || data.success === false) {
    const erreur = new Error(data.message || `Erreur ${response.status}`);
    erreur.code = data.code;
    throw erreur;
  }
  return data;
};

export const annulationPrivilegieeApi = {
  apercu: async (avanceId) => (await appeler(`/api/avances/${avanceId}/annulation-privilegiee`)).data,
  demander: (avanceId, donnees) => appeler(`/api/avances/${avanceId}/annulation-privilegiee`, {
    method: 'POST',
    body: JSON.stringify(donnees)
  }),
  journal: async () => (await appeler('/api/avances/annulation-privilegiee/journal')).data || []
};
